module.exports = __webpack_public_path__ + "static/media/air-india-tail.83b5efb5.png";